module.exports = __webpack_public_path__ + "img/icon7.c1e1d556.png";